import { NgModule } from '@angular/core';
import { AuthService} from './auth.service';
import { EmitService } from './emit.service';
import { AuthGuard } from './auth.guard';
import { PacsRepository } from './pacs.repository';
import { HttpServices} from './httpservices/http.service'
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common'; 
import { HomeService } from './home.service';
import { StudyService } from './study.service';


@NgModule({
  declarations: [

  ],

  imports: [
    HttpClientModule,
    CommonModule
  ],

  exports:[


  ],
  providers: [  
    AuthService,EmitService,PacsRepository,AuthGuard,HttpServices,
    HomeService,StudyService,
  ],
})
export class ServiceModule { }
